<template>
  <div>
    <common-dialog
      ref="dialog"
      width="350px"
      show-save-button
      unit="职务"
      id-key="JobId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="职务名称" prop="JobName">
              <el-input size="mini" v-model="data.JobName" placeholder="请填写职务名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="序号" prop="Sort">
              <el-input-number :min="0" v-model="data.Sort"></el-input-number>
              <!-- <span class="t-tips">值越小排得越前</span> -->
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        JobId: 0,
        JobName: "",
        Sort: 0,
      },
      api: require("@/api/fa/job").default,
      isMB: this.$store.state.isMB,
      rules: {
        JobName: [{ required: true, message: "请填写职务名称" }],
        Sort: [{ required: true, message: "请填写序号" },{ validator: this.$commonJs.validateRules.int }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSort().then(res => {
        this.data.Sort = res.Data
      })
    },
    onEditOpened() {
    },
    onBeforeSave() {
    },
  },
};
</script>
<style lang="scss">
</style>